import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, unref as _unref, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/images/id-card/sample-right.png'
import _imports_1 from '@/assets/images/id-card/sample-right@2x.png'
import _imports_2 from '@/assets/images/id-card/sample-error-1.png'
import _imports_3 from '@/assets/images/id-card/sample-error-1@2x.png'
import _imports_4 from '@/assets/images/id-card/sample-error-2.png'
import _imports_5 from '@/assets/images/id-card/sample-error-2@2x.png'
import _imports_6 from '@/assets/images/id-card/sample-error-3.png'
import _imports_7 from '@/assets/images/id-card/sample-error-3@2x.png'


const _hoisted_1 = _imports_1 + ' 2x'
const _hoisted_2 = _imports_3 + ' 2x'
const _hoisted_3 = _imports_5 + ' 2x'
const _hoisted_4 = _imports_7 + ' 2x'
const _hoisted_5 = { class: "id-card" }
const _hoisted_6 = { class: "id-card-title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 0,
  class: "id-card-upload"
}
const _hoisted_11 = {
  key: 1,
  class: "passport"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "id-card-upload" }

import { computed, onMounted, Ref, ref } from 'vue'
import { useRouter } from 'vue-router'
import { nanoid } from 'nanoid'
import { useToggle } from '@vant/use'
import { ImagePreview } from 'vant'
import uploadApi from '@/axios/upload'
import { ImageType, BusinessType, IdKindType, Source, OpenType, CameraOptions, FormType, OpenAccountTypeMap } from '@/enum'
import useOpenInfo from '@/hooks/openInfo'
import { dataURLtoFile, unzip } from '@/utils/file'
import { getPictureAction, isInAppWebview } from '@/utils/native-app'
import getLastNameAndFirstName from '@/utils/name'
import beforeUpload from '@/utils/before-upload'
import stepPercentage from '@/utils/number'
import { nations } from '@/consts/index'
import * as storage from '@/utils/storage'
import { Message } from '@/components/Message'
import { useLazyQuery, useMutation, useQuery } from '@vue/apollo-composable'
import { queryApi } from '@/graphql/query'
import { dobuleSaveDraft } from '@/graphql/mutation'

interface Ev2 {
  faceType: number;
  blackType: number;
}

interface Ev1 {
  [key: number]: Ev2;
}

interface FileModel {
  url: string;
  status?: string;
  message?: string;
  remoteUrl?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const defaultFace = require('@/assets/images/shenfenzheng-a@2x.png')
const defaultBack = require('@/assets/images/shenfenz-b@2x.png')

const router = useRouter()
const idKind = ref(IdKindType.HK_PERMANENT_ID_CARD)
const faceIdCard: Ref<FileModel[]> = ref([])
const backIdCard: Ref<FileModel[]> = ref([])
const passportCard: Ref<FileModel[]> = ref([])
const noChain1BackIdCard: Ref<FileModel[]> = ref([])
const noChain2BackIdCard: Ref<FileModel[]> = ref([])
const tempImagesList: Ref<any[]> = ref([])
const commomParams = ref()
// 身份证正面相机控制面板
const [faceActionState, faceActionToggle] = useToggle()
const [backActionState, backActionToggle] = useToggle()
const [passportActionState, passportActionToggle] = useToggle()
const [noChain1BackActionState, noChina1BackActionToggle] = useToggle()
const [noChain2BackActionState, noChina2BackActionToggle] = useToggle()
// 相机选项
const actionsList = [
  { key: CameraOptions.CAMERA, name: '拍摄' },
  { key: CameraOptions.PHOTO, name: '相册' }
]
// vuex store数据
const { openType, openInfo, meta, step, saveOpenInfoOfVuex, saveCommonOfVuex } = useOpenInfo()

// 获取storage中的formType,用来区分普通开户和投资移民户
const formTypeVal = computed(() => storage.get('formType'))

const nationOption = computed(() => {
  const arr = [
    { text: '香港永久居民', value: IdKindType.HK_PERMANENT_ID_CARD },
    { text: '香港非永久居民', value: IdKindType.HK_TEMPORARY_ID_CARD },
    { text: '台湾居民', value: IdKindType.TAIWAN_ID_CARD },
    { text: '澳门居民', value: IdKindType.MACAU_ID_CARD },
    { text: '其他国家/地区居民', value: IdKindType.OTHERS }
  ]
  if (formTypeVal.value === FormType.OPEN_IMMIGRANT_ACCOUNT) {
    return arr.filter(item => ![IdKindType.HK_PERMANENT_ID_CARD, IdKindType.HK_TEMPORARY_ID_CARD].includes(item.value))
  }
  return arr
})

// 非大陆身份证
const isOverseas = computed(() => {
  if (openType.value === OpenType.OVERSEAS) {
    return true
  }
  return false
})

// 是否为护照
const isPassport = computed(() => {
  if (idKind.value === IdKindType.OTHERS) {
    return true
  }
  return false
})

// 是否显示护照
const isShowPassport = computed(() => {
  const v = [
    IdKindType.HK_TEMPORARY_ID_CARD,
    IdKindType.TAIWAN_ID_CARD,
    IdKindType.MACAU_ID_CARD,
    IdKindType.OTHERS
  ]
  if (v.includes(idKind.value)) {
    return true
  }
  return false
})
// 是否显示护照titile
const isShowPassportTitle = computed(() => {
  const v = [
    IdKindType.HK_TEMPORARY_ID_CARD,
    IdKindType.TAIWAN_ID_CARD,
    IdKindType.MACAU_ID_CARD
  ]
  if (v.includes(idKind.value)) {
    return true
  }
  return false
})

const prePathName = computed(() => {
  if (formTypeVal.value === FormType.OPEN_IMMIGRANT_ACCOUNT) {
    return 'account-type'
  }
  return 'id-type'
})

const imageTypeParams: Ev1 = {
  2: {
    faceType: ImageType.ACC_IMAGE_TYPE_103,
    blackType: ImageType.ACC_IMAGE_TYPE_104
  },
  3: {
    faceType: ImageType.ACC_IMAGE_TYPE_105,
    blackType: ImageType.ACC_IMAGE_TYPE_106
  },
  4: {
    faceType: ImageType.ACC_IMAGE_TYPE_108,
    blackType: ImageType.ACC_IMAGE_TYPE_109
  },
  5: {
    faceType: ImageType.ACC_IMAGE_TYPE_110,
    blackType: ImageType.ACC_IMAGE_TYPE_111
  },
  6: {
    faceType: ImageType.ACC_IMAGE_TYPE_107,
    blackType: ImageType.ACC_IMAGE_TYPE_107
  }
}

// 判断是否在金马app内
const isApp = computed(() => isInAppWebview())

// 查询图片缓存
const { onResult, refetch: queryFileTemp } = useQuery(queryApi.fileTempQuery, {
  params: {
    kindSource: openType.value,
    openAccountType: OpenAccountTypeMap[formTypeVal.value as string]
  }
})

onResult((res) => {
  const { fileTempQuery } = res.data
  if (fileTempQuery.ok) {
    tempImagesList.value = fileTempQuery.data
    formatImages()
  }
})

// 唤起app相机
const faceIdCardOfApp = () => {
  if (!isApp.value || faceIdCard.value.length) {
    return
  }
  faceActionToggle(true)
}

// 唤起app相机 非大陆证件1
const noChina1BackIdCardOfApp = () => {
  if (!isApp.value || noChain1BackIdCard.value.length) {
    return
  }
  noChina1BackActionToggle(true)
}

const noChina2BackIdCardOfApp = () => {
  if (!isApp.value || noChain2BackIdCard.value.length) {
    return
  }
  noChina2BackActionToggle(true)
}

const backIdCardOfApp = () => {
  if (!isApp.value || backIdCard.value.length) {
    return
  }
  backActionToggle(true)
}
const passportOfApp = () => {
  if (!isApp.value || passportCard.value.length) {
    return
  }
  passportActionToggle(true)
}

// 调用接口上传身份证正面照
const uploadFaceIdCard = (file: File) => {
  beforeUpload(file).then((res: any) => {
    const formatFile = new File([res], res.name, { type: res.type })
    faceIdCard.value = [
      {
        url: '',
        status: 'uploading',
        message: '上传中...'
      }
    ]
    const params = {
      file: formatFile,
      imageType:
        openType.value === 1
          ? ImageType.ACC_IMAGE_TYPE_101
          : imageTypeParams[idKind.value].faceType,
      businessType: BusinessType.ACC_FILE_BUSINESS_TYPE_1,
      idKindType: idKind.value,
      kindSource: openType.value,
      source: Source.H5
    }
    uploadApi.uploadFile(params).then((res: any) => {
      const { openAccountUploadFile } = res
      if (openAccountUploadFile) {
        faceIdCard.value = [
          {
            url: openAccountUploadFile.data,
            status: 'done'
          }
        ]
      } else {
        console.log('上传失败')
        faceIdCard.value = []
        Message({
          direction: 'vertical',
          text: openAccountUploadFile?.reason?.desc || '上传失败，请重试'
        })
      }
    }).catch(() => {
      faceIdCard.value = []
    })
  })
}

// 调用接口上传身份证背面照
const uploadBackIdCard = (file: File) => {
  beforeUpload(file).then((res: any) => {
    const formatFile = new File([res], res.name, { type: res.type })
    backIdCard.value = [
      {
        url: '',
        status: 'uploading',
        message: '上传中...'
      }
    ]
    const params = {
      file: formatFile,
      imageType:
        openType.value === 1
          ? ImageType.ACC_IMAGE_TYPE_102
          : imageTypeParams[idKind.value].blackType,
      businessType: BusinessType.ACC_FILE_BUSINESS_TYPE_1,
      idKindType: idKind.value,
      kindSource: openType.value,
      source: Source.H5
    }
    uploadApi.uploadFile(params).then((res: any) => {
      const { openAccountUploadFile } = res
      if (openAccountUploadFile) {
        backIdCard.value = [
          {
            url: openAccountUploadFile.data,
            status: 'done'
          }
        ]
      } else {
        console.log('上传失败')
        backIdCard.value = []
        Message({
          direction: 'vertical',
          text: openAccountUploadFile?.reason?.desc || '上传失败，请重试'
        })
      }
    }).catch(() => {
      backIdCard.value = []
    })
  })
}

// 调用接口上传身份证背面照
const uploadPassport = (file: File) => {
  beforeUpload(file).then((res: any) => {
    const formatFile = new File([res], res.name, { type: res.type })
    passportCard.value = [
      {
        url: '',
        status: 'uploading',
        message: '上传中...'
      }
    ]
    const params = {
      file: formatFile,
      imageType: ImageType.ACC_IMAGE_TYPE_107,
      businessType: BusinessType.ACC_FILE_BUSINESS_TYPE_1,
      idKindType: idKind.value,
      kindSource: openType.value,
      source: Source.H5
    }
    uploadApi.uploadFile(params).then((res: any) => {
      const { openAccountUploadFile } = res
      if (openAccountUploadFile) {
        passportCard.value = [
          {
            url: openAccountUploadFile.data,
            status: 'done'
          }
        ]
      } else {
        console.log('上传失败')
        Message({
          direction: 'vertical',
          text: openAccountUploadFile?.reason?.desc || '上传失败，请重试'
        })
      }
    }).catch(() => {
      passportCard.value = []
    })
  })
}

// 调用接口上传身份证背面照
const uploadNoChain1Back = (file: File) => {
  beforeUpload(file).then((res: any) => {
    const formatFile = new File([res], res.name, { type: res.type })
    passportCard.value = [
      {
        url: '',
        status: 'uploading',
        message: '上传中...'
      }
    ]
    const params = {
      file: formatFile,
      imageType: ImageType.ACC_IMAGE_TYPE_112,
      businessType: BusinessType.ACC_FILE_BUSINESS_TYPE_1,
      idKindType: idKind.value,
      kindSource: openType.value,
      source: Source.H5
    }
    uploadApi.uploadFile(params).then((res: any) => {
      const { openAccountUploadFile } = res
      if (openAccountUploadFile) {
        noChain1BackIdCard.value = [
          {
            url: openAccountUploadFile.data,
            status: 'done'
          }
        ]
      } else {
        console.log('上传失败')
        Message({
          direction: 'vertical',
          text: openAccountUploadFile?.reason?.desc || '上传失败，请重试'
        })
      }
    }).catch(() => {
      passportCard.value = []
    })
  })
}

// 调用接口上传非大陆身份证背面照
const uploadNoChain2Back = (file: File) => {
  beforeUpload(file).then((res: any) => {
    const formatFile = new File([res], res.name, { type: res.type })
    passportCard.value = [
      {
        url: '',
        status: 'uploading',
        message: '上传中...'
      }
    ]
    const params = {
      file: formatFile,
      imageType: ImageType.ACC_IMAGE_TYPE_113,
      businessType: BusinessType.ACC_FILE_BUSINESS_TYPE_1,
      idKindType: idKind.value,
      kindSource: openType.value,
      source: Source.H5
    }
    uploadApi.uploadFile(params).then((res: any) => {
      const { openAccountUploadFile } = res
      if (openAccountUploadFile) {
        noChain2BackIdCard.value = [
          {
            url: openAccountUploadFile.data,
            status: 'done'
          }
        ]
      } else {
        console.log('上传失败')
        Message({
          direction: 'vertical',
          text: openAccountUploadFile?.reason?.desc || '上传失败，请重试'
        })
      }
    }).catch(() => {
      passportCard.value = []
    })
  })
}

// 身份证正面上传前钩子
const beforeReadFace = (file: File) => {
  uploadFaceIdCard(file)
}
// 身份证背面上传前钩子
const beforeReadBack = (file: File) => {
  uploadBackIdCard(file)
}
// 护照上传前钩子
const beforeReadPassport = (file: File) => {
  uploadPassport(file)
}

// 身份证正面上传前钩子
const beforeReadNoChain1Back = (file: File) => {
  uploadNoChain1Back(file)
}

// 身份证背面上传前钩子
const beforeReadNoChain2Back = (file: File) => {
  uploadNoChain2Back(file)
}

// 选择相机或者相册
const onFaceSelect = async (item: { key: string }) => {
  const url = await getPictureAction(item.key)
  if (url) {
    const base64 = unzip(url)
    const imgUrl = `data:image/png;base64,${base64}`
    const png = dataURLtoFile(imgUrl, `${nanoid()}.png`)
    uploadFaceIdCard(png)
  }
}

// 选择相机或者相册
const onBackSelect = async (item: { key: string }) => {
  const url = await getPictureAction(item.key)
  if (url) {
    const base64 = unzip(url)
    const imgUrl = `data:image/png;base64,${base64}`
    const file = dataURLtoFile(imgUrl, `${nanoid()}.png`)
    uploadBackIdCard(file)
  }
}
// 选择相机或者相册
const onNoChain1BackSelect = async (item: { key: string }) => {
  const url = await getPictureAction(item.key)
  if (url) {
    const base64 = unzip(url)
    const imgUrl = `data:image/png;base64,${base64}`
    const file = dataURLtoFile(imgUrl, `${nanoid()}.png`)
    uploadNoChain1Back(file)
  }
}

// 选择相机或者相册
const onNoChain2BackSelect = async (item: { key: string }) => {
  const url = await getPictureAction(item.key)
  if (url) {
    const base64 = unzip(url)
    const imgUrl = `data:image/png;base64,${base64}`
    const file = dataURLtoFile(imgUrl, `${nanoid()}.png`)
    uploadNoChain2Back(file)
  }
}

// 选择相机或者相册
const onPassportSelect = async (item: { key: string }) => {
  const url = await getPictureAction(item.key)
  if (url) {
    const base64 = unzip(url)
    const imgUrl = `data:image/png;base64,${base64}`
    const file = dataURLtoFile(imgUrl, `${nanoid()}.png`)
    uploadPassport(file)
  }
}

// 删除身份证正面
const faceIdCardDel = () => {
  faceIdCard.value = []
}

// 删除身份证反面
const backIdCardDel = () => {
  backIdCard.value = []
}

// 删除护照
const passportCardDel = () => {
  passportCard.value = []
}

const noChain1BackIdCardDel = () => {
  noChain1BackIdCard.value = []
}

const noChain2BackIdCardDel = () => {
  noChain2BackIdCard.value = []
}

// 对于缓存图片放置格式化
const formatImages = () => {
  if (idKind.value === IdKindType.MAINLAND_ID_CARD) {
    const face = tempImagesList.value?.filter(
      (val: { imageType: number }) => val.imageType === ImageType.ACC_IMAGE_TYPE_101
    )
    const back = tempImagesList.value?.filter(
      (val: { imageType: number }) => val.imageType === ImageType.ACC_IMAGE_TYPE_102
    )
    faceIdCard.value = face?.length ? [{ url: face[0].remoteUrl, status: 'done' }] : []
    backIdCard.value = back?.length ? [{ url: back[0].remoteUrl, status: 'done' }] : []
  } else if (idKind.value === IdKindType.HK_PERMANENT_ID_CARD) {
    const face = tempImagesList.value?.filter(
      (val: { imageType: number }) => val.imageType === ImageType.ACC_IMAGE_TYPE_103
    )
    const back = tempImagesList.value?.filter(
      (val: { imageType: number }) => val.imageType === ImageType.ACC_IMAGE_TYPE_104
    )
    faceIdCard.value = face.length ? [{ url: face[0].remoteUrl, status: 'done' }] : []
    backIdCard.value = back.length ? [{ url: back[0].remoteUrl, status: 'done' }] : []
  } else if (idKind.value === IdKindType.HK_TEMPORARY_ID_CARD) {
    const face = tempImagesList.value?.filter(
      (val: { imageType: number }) => val.imageType === ImageType.ACC_IMAGE_TYPE_105
    )
    const back = tempImagesList.value?.filter(
      (val: { imageType: number }) => val.imageType === ImageType.ACC_IMAGE_TYPE_106
    )
    const passportList = tempImagesList.value?.filter(
      (val: { imageType: number; idKindType: number }) =>
        val.imageType === ImageType.ACC_IMAGE_TYPE_107 &&
        val.idKindType === IdKindType.HK_TEMPORARY_ID_CARD
    )
    faceIdCard.value = face.length ? [{ url: face[0].remoteUrl, status: 'done' }] : []
    backIdCard.value = back.length ? [{ url: back[0].remoteUrl, status: 'done' }] : []
    passportCard.value = passportList.length
      ? [{ url: passportList[0].remoteUrl, status: 'done' }]
      : []
  } else if (idKind.value === IdKindType.TAIWAN_ID_CARD) {
    const face = tempImagesList.value?.filter(
      (val: { imageType: number }) => val.imageType === ImageType.ACC_IMAGE_TYPE_108
    )
    const back = tempImagesList.value?.filter(
      (val: { imageType: number }) => val.imageType === ImageType.ACC_IMAGE_TYPE_109
    )
    const passportList = tempImagesList.value?.filter(
      (val: { imageType: number; idKindType: number }) =>
        val.imageType === ImageType.ACC_IMAGE_TYPE_107 &&
        val.idKindType === IdKindType.TAIWAN_ID_CARD
    )
    faceIdCard.value = face.length ? [{ url: face[0].remoteUrl, status: 'done' }] : []
    backIdCard.value = back.length ? [{ url: back[0].remoteUrl, status: 'done' }] : []
    passportCard.value = passportList.length
      ? [{ url: passportList[0].remoteUrl, status: 'done' }]
      : []
  } else if (idKind.value === IdKindType.MACAU_ID_CARD) {
    const face = tempImagesList.value?.filter(
      (val: { imageType: number }) => val.imageType === ImageType.ACC_IMAGE_TYPE_110
    )
    const back = tempImagesList.value?.filter(
      (val: { imageType: number }) => val.imageType === ImageType.ACC_IMAGE_TYPE_111
    )
    const passportList = tempImagesList.value?.filter(
      (val: { imageType: number; idKindType: number }) =>
        val.imageType === ImageType.ACC_IMAGE_TYPE_107 &&
        val.idKindType === IdKindType.MACAU_ID_CARD
    )
    console.log('passportList', passportList)
    faceIdCard.value = face.length ? [{ url: face[0].remoteUrl, status: 'done' }] : []
    backIdCard.value = back.length ? [{ url: back[0].remoteUrl, status: 'done' }] : []
    passportCard.value = passportList.length
      ? [{ url: passportList[0].remoteUrl, status: 'done' }]
      : []
  } else if (idKind.value === IdKindType.OTHERS) {
    const pngList = tempImagesList.value?.filter(
      (val: { imageType: number; idKindType: number }) =>
        val.imageType === ImageType.ACC_IMAGE_TYPE_107 && val.idKindType === IdKindType.OTHERS
    )
    passportCard.value = pngList.length ? [{ url: pngList[0].remoteUrl, status: 'done' }] : []
  }
  if (formTypeVal.value === FormType.OPEN_IMMIGRANT_ACCOUNT) {
    const noChain1Back = tempImagesList.value?.filter(
      (val: { imageType: number }) => val.imageType === ImageType.ACC_IMAGE_TYPE_112
    )
    const noChain2Back = tempImagesList.value?.filter(
      (val: { imageType: number }) => val.imageType === ImageType.ACC_IMAGE_TYPE_113
    )
    noChain1BackIdCard.value = noChain1Back?.length ? [{ url: noChain1Back[0].remoteUrl, status: 'done' }] : []
    noChain2BackIdCard.value = noChain2Back?.length ? [{ url: noChain2Back[0].remoteUrl, status: 'done' }] : []
  }
}

const initData = () => {
  if (isOverseas.value) {
    idKind.value = openInfo.value.idKind ? openInfo.value.idKind : formTypeVal.value === FormType.OPEN_IMMIGRANT_ACCOUNT ? 4 : idKind.value
  } else {
    idKind.value = openInfo.value.idKind ? openInfo.value.idKind : 1
  }
}

// 选择证件类型
const idKindHandle = () => {
  queryFileTemp({
    params: {
      kindSource: openType.value,
      openAccountType: OpenAccountTypeMap[formTypeVal.value as string]
    }
  })
}

// 禁用 置灰
const isDisabled = computed(() => {
  if (idKind.value === IdKindType.OTHERS) {
    return !(passportCard.value.length && passportCard.value[0].status === 'done')
  }
  if (formTypeVal.value === FormType.OPEN_IMMIGRANT_ACCOUNT && !isOverseas.value) {
    return !(
      ((noChain1BackIdCard.value.length &&
      noChain1BackIdCard.value[0].status === 'done') ||
      (noChain2BackIdCard.value.length &&
      noChain2BackIdCard.value[0].status === 'done')) && (
        faceIdCard.value.length &&
    faceIdCard.value[0].status === 'done' &&
    backIdCard.value.length &&
    backIdCard.value[0].status === 'done'
      )
    )
  }
  return !(
    faceIdCard.value.length &&
    faceIdCard.value[0].status === 'done' &&
    backIdCard.value.length &&
    backIdCard.value[0].status === 'done'
  )
})

// 存储缓存表方法
const { mutate: saveClientDraft, onDone } = useMutation(dobuleSaveDraft)

onDone((res) => {
  const { saveClientFormDraft, commonDraft } = res.data
  if (saveClientFormDraft.ok && commonDraft.ok) {
    saveCommonOfVuex({ info: commomParams.value })
    saveOpenInfoOfVuex({ info: { idKind: isOverseas.value ? idKind.value : 1 } })
    router.push({ name: 'id-card-info' })
  } else {
    Message({ direction: 'vertical', text: '请求异常，请稍后重试！(Draft)' })
  }
})

// 获取大陆身份证OCR
const { load: getMainLandCardOcr, onResult: mainLandCardOcrResult } = useLazyQuery(queryApi.mainlandIdCardOcr)

mainLandCardOcrResult((res) => {
  const { mainlandIdCardOcr } = res.data
  let info
  if (mainlandIdCardOcr.ok) {
    const { lastName, firstName } = getLastNameAndFirstName(mainlandIdCardOcr.data.name || '')
    info = {
      sex: mainlandIdCardOcr.data.sex === 'M' ? '0' : '1',
      familyName: lastName,
      givenName: firstName,
      idNo: mainlandIdCardOcr.data.idNum,
      idCardAddress: mainlandIdCardOcr.data.address,
      birthday: mainlandIdCardOcr.data.birthday?.replace(/\//g, '-')
    }
  }
  saveOpenInfoOfVuex({
    info
  })
  saveNext()
})

// 获取香港身份证OCR接口
const { load: getHkIdCardOcr, onResult: hkIdCardOcrResult } = useLazyQuery(queryApi.hkIdCardOcr)

hkIdCardOcrResult((res) => {
  const { hkIdCardOcr } = res.data
  let info
  if (hkIdCardOcr.ok) {
    const { lastName, firstName } = getLastNameAndFirstName(hkIdCardOcr.data.name || '')
    info = {
      sex: hkIdCardOcr.data.sex === 'M' ? '0' : '1',
      familyName: lastName,
      givenName: firstName,
      idNo: hkIdCardOcr.data.idNum,
      idCardAddress: hkIdCardOcr.data.address,
      birthday: hkIdCardOcr.data.birthday?.replace(/\//g, '-')
    }
  }
  saveOpenInfoOfVuex({
    info
  })
  saveNext()
})

// 获取护照OCR
const { load: getPassportOcr, onResult: passportResult } = useLazyQuery(queryApi.overseasPassportOcr)

passportResult((res) => {
  const { overseasPassportOcr } = res.data
  let info
  if (overseasPassportOcr.ok) {
    const len = overseasPassportOcr.data.name.split(' ').length
    info = {
      sex: overseasPassportOcr.data.sex === 'M' ? '0' : '1',
      familyNameSpell: len === 2 ? overseasPassportOcr.data.name.split(' ')[0] : '',
      givenNameSpell: len === 2 ? overseasPassportOcr.data.name.split(' ')[1] : '',
      idNo: overseasPassportOcr.data.passportNo,
      certificateIssuingCountry: overseasPassportOcr.data.country,
      certificateIssuingCountryText: nations[overseasPassportOcr.data.country],
      nationality: overseasPassportOcr.data.nationality,
      nationalityText: nations[overseasPassportOcr.data.nationality]
    }
  }
  saveOpenInfoOfVuex({
    info
  })
  saveNext()
})

// 校验通过 进入下一步
const saveNext = () => {
  const percentage = stepPercentage(step)
  commomParams.value = {
    openType: openType.value,
    openStatus: 0,
    btnText: '继续开户',
    remark: `已完成${percentage}%，请继续完善资料`,
    step
  }

  saveClientDraft({
    param: {
      formType: formTypeVal.value,
      meta: meta.value,
      content: JSON.stringify({ idKind: isOverseas.value ? idKind.value : 1 })
    },
    commomParams: {
      formType: formTypeVal.value,
      meta: 'open_common',
      content: JSON.stringify(commomParams.value)
    }
  })
}

// 下一步
const handleNext = () => {
  if (isDisabled.value) {
    return
  }
  switch (idKind.value) {
    case 1:
      getMainLandCardOcr(queryApi.mainlandIdCardOcr, {
        params: {
          imageUrl: faceIdCard.value[0].url
        }
      })
      break
    case 2:
    case 3:
      getHkIdCardOcr(queryApi.hkIdCardOcr, {
        params: {
          imageUrl: faceIdCard.value[0].url
        }
      })
      break
    case 6:
      getPassportOcr(queryApi.overseasPassportOcr, {
        params: {
          imageUrl: passportCard.value[0].url
        }
      })
      break
    default:
      saveNext()
      break
  }
}

onMounted(() => {
  initData()
})
const viewExp = () => {
  let img = ''
  if (!isOverseas.value) {
    img = require('../../assets/images/mainland.png')
  } else if (idKind.value === 2) {
    img = require('../../assets/images/hknonpermanent.jpg')
  } else if (idKind.value === 3) {
    img = require('../../assets/images/hkpermanent.jpg')
  } else if (idKind.value === 4) {
    img = require('../../assets/images/twn.png')
  } else if (idKind.value === 5) {
    img = require('../../assets/images/mac.png')
  }
  ImagePreview({
    images: [img],
    closeable: true
  })
}

return (_ctx: any,_cache: any) => {
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: handleNext,
    isDisabled: isDisabled.value,
    prePathName: prePathName.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            (!isOverseas.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "上传您本人的中国大陆身份证"))
              : (isPassport.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, "上传您本人的护照"))
                : (_openBlock(), _createElementBlock("p", _hoisted_9, "上传您本人的身份证件"))
          ]),
          (isOverseas.value)
            ? (_openBlock(), _createBlock(_component_van_dropdown_menu, {
                key: 0,
                class: "id-card-type",
                "active-color": "#fff"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_dropdown_item, {
                    modelValue: idKind.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((idKind).value = $event)),
                    options: nationOption.value,
                    onChange: idKindHandle
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "id-card-tip" }, "您的身份信息仅用于开户，并受到严格保护。", -1)),
        _createElementVNode("div", null, [
          (!isPassport.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", { onClick: faceIdCardOfApp }, [
                  _createVNode(_component_van_uploader, {
                    modelValue: faceIdCard.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((faceIdCard).value = $event)),
                    "before-read": beforeReadFace,
                    "max-count": "1",
                    deletable: false,
                    readonly: isApp.value
                  }, {
                    "preview-cover": _withCtx(() => [
                      _createElementVNode("div", {
                        class: "preview-cover",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (faceIdCardDel()), ["stop"]))
                      }, _cache[16] || (_cache[16] = [
                        _createElementVNode("i", { class: "iconfont icon-cangpeitubiao_shanchu" }, null, -1)
                      ]))
                    ]),
                    default: _withCtx(() => [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "face-sample" }, [
                        _createElementVNode("p", { class: "text" }, "身份证正面-人像")
                      ], -1))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "readonly"])
                ]),
                _createElementVNode("div", { onClick: backIdCardOfApp }, [
                  _createVNode(_component_van_uploader, {
                    modelValue: backIdCard.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((backIdCard).value = $event)),
                    "before-read": beforeReadBack,
                    "max-count": "1",
                    readonly: isApp.value,
                    deletable: false
                  }, {
                    "preview-cover": _withCtx(() => [
                      _createElementVNode("div", {
                        class: "preview-cover",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (backIdCardDel()), ["stop"]))
                      }, _cache[18] || (_cache[18] = [
                        _createElementVNode("i", { class: "iconfont icon-cangpeitubiao_shanchu" }, null, -1)
                      ]))
                    ]),
                    default: _withCtx(() => [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "back-sample" }, [
                        _createElementVNode("p", { class: "text" }, "身份证反面-国徽")
                      ], -1))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "readonly"])
                ])
              ]))
            : _createCommentVNode("", true),
          (isShowPassportTitle.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 上传护照 "))
            : _createCommentVNode("", true),
          (isShowPassport.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", { onClick: passportOfApp }, [
                  _createVNode(_component_van_uploader, {
                    modelValue: passportCard.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((passportCard).value = $event)),
                    "before-read": beforeReadPassport,
                    "max-count": "1",
                    readonly: isApp.value,
                    deletable: false
                  }, {
                    "preview-cover": _withCtx(() => [
                      _createElementVNode("div", {
                        class: "preview-cover",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (passportCardDel()), ["stop"]))
                      }, _cache[20] || (_cache[20] = [
                        _createElementVNode("i", { class: "iconfont icon-cangpeitubiao_shanchu" }, null, -1)
                      ]))
                    ]),
                    default: _withCtx(() => [
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "passport-sample" }, [
                        _createElementVNode("p", { class: "text" }, "护照正面")
                      ], -1))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "readonly"])
                ])
              ]))
            : _createCommentVNode("", true),
          (formTypeVal.value === _unref(FormType).OPEN_IMMIGRANT_ACCOUNT && !isOverseas.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "id-card-title" }, "上传非中国大陆身份证件", -1)),
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "id-card-tip" }, "如澳台或海外居民证件", -1)),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", { onClick: noChina1BackIdCardOfApp }, [
                    _createVNode(_component_van_uploader, {
                      modelValue: noChain1BackIdCard.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((noChain1BackIdCard).value = $event)),
                      "before-read": beforeReadNoChain1Back,
                      "max-count": "1",
                      deletable: false,
                      readonly: isApp.value
                    }, {
                      "preview-cover": _withCtx(() => [
                        _createElementVNode("div", {
                          class: "preview-cover",
                          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (noChain1BackIdCardDel()), ["stop"]))
                        }, _cache[22] || (_cache[22] = [
                          _createElementVNode("i", { class: "iconfont icon-cangpeitubiao_shanchu" }, null, -1)
                        ]))
                      ]),
                      default: _withCtx(() => [
                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "face-sample" }, [
                          _createElementVNode("p", { class: "text" }, "证件1")
                        ], -1))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "readonly"])
                  ]),
                  _createElementVNode("div", { onClick: noChina2BackIdCardOfApp }, [
                    _createVNode(_component_van_uploader, {
                      modelValue: noChain2BackIdCard.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((noChain2BackIdCard).value = $event)),
                      "before-read": beforeReadNoChain2Back,
                      "max-count": "1",
                      readonly: isApp.value,
                      deletable: false
                    }, {
                      "preview-cover": _withCtx(() => [
                        _createElementVNode("div", {
                          class: "preview-cover",
                          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (noChain2BackIdCardDel()), ["stop"]))
                        }, _cache[24] || (_cache[24] = [
                          _createElementVNode("i", { class: "iconfont icon-cangpeitubiao_shanchu" }, null, -1)
                        ]))
                      ]),
                      default: _withCtx(() => [
                        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "back-sample" }, [
                          _createElementVNode("p", { class: "text" }, "证件2")
                        ], -1))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "readonly"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "tips" }, "请确保证件内容清晰可见，无反光，无水印，缺角。", -1)),
          (!isPassport.value)
            ? (_openBlock(), _createElementBlock("p", {
                key: 4,
                class: "sample",
                onClick: viewExp
              }, "查看正确示例"))
            : _createCommentVNode("", true),
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "example" }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", { class: "img" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  srcset: _hoisted_1,
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "标准")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", { class: "img" }, [
                _createElementVNode("img", {
                  src: _imports_2,
                  srcset: _hoisted_2,
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "边框缺失")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", { class: "img" }, [
                _createElementVNode("img", {
                  src: _imports_4,
                  srcset: _hoisted_3,
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "照片模糊")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", { class: "img" }, [
                _createElementVNode("img", {
                  src: _imports_6,
                  srcset: _hoisted_4,
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "闪光强烈")
            ])
          ], -1))
        ])
      ]),
      _createVNode(_component_van_action_sheet, {
        show: _unref(faceActionState),
        "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => (_isRef(faceActionState) ? (faceActionState).value = $event : null)),
        actions: actionsList,
        "cancel-text": "取消",
        "close-on-click-action": "",
        onSelect: onFaceSelect
      }, null, 8, ["show"]),
      _createVNode(_component_van_action_sheet, {
        show: _unref(backActionState),
        "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => (_isRef(backActionState) ? (backActionState).value = $event : null)),
        actions: actionsList,
        "cancel-text": "取消",
        "close-on-click-action": "",
        onSelect: onBackSelect
      }, null, 8, ["show"]),
      _createVNode(_component_van_action_sheet, {
        show: _unref(passportActionState),
        "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => (_isRef(passportActionState) ? (passportActionState).value = $event : null)),
        actions: actionsList,
        "cancel-text": "取消",
        "close-on-click-action": "",
        onSelect: onPassportSelect
      }, null, 8, ["show"]),
      _createVNode(_component_van_action_sheet, {
        show: _unref(noChain1BackActionState),
        "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => (_isRef(noChain1BackActionState) ? (noChain1BackActionState).value = $event : null)),
        actions: actionsList,
        "cancel-text": "取消",
        "close-on-click-action": "",
        onSelect: onNoChain1BackSelect
      }, null, 8, ["show"]),
      _createVNode(_component_van_action_sheet, {
        show: _unref(noChain2BackActionState),
        "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => (_isRef(noChain2BackActionState) ? (noChain2BackActionState).value = $event : null)),
        actions: actionsList,
        "cancel-text": "取消",
        "close-on-click-action": "",
        onSelect: onNoChain2BackSelect
      }, null, 8, ["show"])
    ]),
    _: 1
  }, 8, ["isDisabled", "prePathName"]))
}
}

})